<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import NumberUtils from '@/utils/number'
import NormcaseService from '@/request/databank/NormCase'
import NormcasePraiseService from '@/request/databank/NormCasePraise'
export default {
  computed: {
    ...mapGetters('databank', {
      listOptions: 'listOptions',
      listPagination: 'listPagination'
    })
  },
  components: {},
  data () {
    return {
      listLoading: false,
      list: [],
      ncids: [],
      praises: {}
    }
  },
  created: function () {
    this.listNormcase()
  },
  mounted: function () {},
  beforeDestroy: function () {},
  watch: {
    'listOptions': {
      deep: true,
      handler () {
        this.listNormcase()
      }
    },
    ncids () {
      this.listPraise()
    }
  },
  methods: {
    listNormcase () {
      this.listLoading = true
      NormcaseService.find(this.listOptions, this.listPagination).then(res => {
        let data = res.result
        this.list = data.content || []
        if (!_.isEmpty(this.list)) {
          let ids = []
          _.forEach(this.list, nc => {
            ids.push(nc.id)
          })
          this.ncids = _.clone(ids)
        }
        this.listPagination.total = data.totalElements || 0
      }).catch(error => {
        this.list = []
        this.$message.error(error || '获取数据出错，请重试')
      }).finally(() => {
        this.listLoading = false
      })
    },
    listPraise () {
      if (_.isEmpty(this.ncids)) {
        this.praises = {}
        return
      }
      NormcasePraiseService.list({
        ncids: _.join(this.ncids)
      }).then(res => {
        let ps = res.result || []
        if (_.isEmpty(ps)) {
          this.praises = {}
          return
        }
        let map = {}
        _.forEach(ps, praise => {
          map[praise.ncid] = _.clone(praise)
        })
        this.praises = _.clone(map)
      })
    },
    handleSizeChange (val) {
      let self = this
      self.listPagination.size = val
      self.listNormcase()
    },
    handleCurrentChange (val) {
      let self = this
      self.listPagination.current = val
      self.listNormcase()
    },
    handleEditNormcase (item) {
      this.$router.push({name: 'databank_normcaseadd', params: {id: item ? item.id : 0}})
    },
    showNormcase (item) {
      if (!item || !item.id) {
        this.$message.error('数据有误，请刷新重试')
        return
      }
      this.$router.push({name: 'databank_normcaseshow', params: {id: item.id}})
    },
    showDoctor (item) {
      if (!item) {
        return
      }
      let doctor = NumberUtils.idFromString(item.operator) || null
      if (!doctor) {
        this.$message({
          message: '这个病例的医生未加入医步用户',
          type: 'info'
        })
        return
      }
      this.$router.push({name: 'databank_normcasedoctor', params: {id: doctor}})
    },
    praise (item) {
      if (!item || !item.id) {
        return
      }
      let ncid = item.id + ''
      NormcasePraiseService.save({
        ncid: ncid
      }).then(res => {
        let pra = res.result || {}
        if (_.isEmpty(pra) || this.praises.hasOwnProperty(ncid)) {
          let map = this.praises
          delete map[ncid]
          this.praises = _.cloneDeep(map)
        } else {
          this.$set(this.praises, ncid, pra)
        }
      }).catch(error => {
        this.$message.error(error || '点赞出现问题，请重试')
      })
    }
  },
  filters: {}
}
</script>

<template>
  <el-container>
    <el-header height="45px" class="clear">
      <el-form :inline="true" class="demo-form-inline left-form" size="small">
        <el-form-item>
          <el-radio-group v-model="listOptions.publicType">
            <el-radio-button label="0,1,2,3">全部</el-radio-button>
            <el-radio-button label="1">公开</el-radio-button>
            <el-radio-button label="2">医院</el-radio-button>
            <el-radio-button label="0">个人</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-input style="width: 18em" v-model="listOptions.match" placeholder="输入医生姓名、科室、诊断查找" clearable></el-input>
        </el-form-item>
      </el-form>
      <el-form :inline="true" class="demo-form-inline right-form" size="small">
        <el-form-item>
          <el-button type="primary" @click="handleEditNormcase()">创建病例</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <el-main>
      <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap" view-class="p20-scrollbar__view">
        <div class="main-container">
          <div class="nc-list" v-loading.body="listLoading">
            <div class="nc-item mb20" v-for="item in list" :key="item.id">
              <el-card shadow="hover" :body-style="{ padding: '0px' }">
                <databank-normcase-window
                  :data="item"
                  :praised="!!praises[item.id]"
                  @click-edit="handleEditNormcase"
                  @click-image="showNormcase"
                  @click-title="showNormcase"
                  @click-operator="showDoctor"
                  @click-praise="praise"
                ></databank-normcase-window>
              </el-card>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </el-main>
    <el-footer height="35px">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="listPagination.current" :page-sizes="listPagination.sizes" :page-size="listPagination.size" :layout="listPagination.layout" :total="listPagination.total"></el-pagination>
    </el-footer>
  </el-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-container {
  width: 800px;
  height: auto;
  margin: 0 auto;
  padding: 0;
}
.nc-list {
  width: 100%;
}
</style>
